<template>
  <div style="display: inline" class="">
    <el-button type="default" size="small" @click="openList()" icon="el-icon-document">
      Listar documentos
    </el-button>
    <el-dialog title="Listado de documentos" :visible.sync="dialogListVisible" :destroy-on-close="true" width="80%" top="5vh">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="8" :md="10" :lg="10" :xl="10" class="mb-10">
          <el-input v-model="document" @clear="document = null"
            @blur="(document == '') ? document = null : document = document" placeholder="Número de documento"
            size="medium" clearable></el-input>
        </el-col>
        <el-col :xs="24" :sm="12" :md="10" :lg="10" :xl="10" class="mb-10">
          <el-date-picker v-model="date_end" value-format="yyyy-MM-dd" type="daterange" align="right" unlink-panels
            range-separator="a" start-placeholder="Fecha inicial" end-placeholder="Fecha final"
            :picker-options="pickerOptions" size="medium">
          </el-date-picker>
        </el-col>
        <el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="4" class="mb-10">
          <el-button type="primary" size="medium" icon="el-icon-search" @click="getAdjust()"
            :loading="loading">Buscar</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-table :data="list" v-loading="loadingTable" empty-text="No hay ajustes" width="100%">
          <el-empty slot="empty" description="No hay datos"></el-empty>
          <el-table-column property="consecutivo" label="Documento" min-width="100px">
            <template slot-scope="scope">
              <div>{{ scope.row.consecutivo }}
                <br>
                <el-popover placement="top-start" title="Concepto anulación" width="300" trigger="hover"
                  :content="scope.row.concepto_anulacion">
                  <el-tag type="danger" size="mini" slot="reference" v-if="scope.row.anulado == 1"><i
                      class="el-icon-view"></i> Anulado</el-tag>
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column property="fecha" label="Fecha" min-width="100px"></el-table-column>
          <el-table-column property="person.nombre" label="Encargado" min-width="100px"></el-table-column>
          <el-table-column property="branch.razon_social" label="Sucursal" min-width="120px"></el-table-column>
          <el-table-column property="observacion" label="Observación" min-width="250px"></el-table-column>
          <el-table-column prop="actioions" label="Acciones" width="240">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="Editar" placement="top">
                <el-button v-if="scope.row.anulado != 1" @click.native.prevent="editDocument(list[scope.$index])"
                  type="primary" plain round size="mini" icon="el-icon-edit" class="ml-5">
                </el-button>
              </el-tooltip>
              <!-- <el-tooltip class="item" effect="dark" content="Imprimir" placement="top">
                <el-button v-if="scope.row.anulado != 1" @click.native.prevent="printDocument(list[scope.$index])" plain
                  round size="mini" icon="el-icon-printer" class="">
                </el-button>
              </el-tooltip> -->
              <el-tooltip class="item" effect="dark" content="Imprimir" placement="top">
                <el-button v-if="scope.row.anulado != 1 && scope.row.tipo_id != '8'" @click.native.prevent="printDocumentPdf(list[scope.$index])"
                  plain round size="mini" icon="el-icon-printer" class="">
                </el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="Remisión de salida" placement="top">
                <el-button v-if="scope.row.anulado != 1 && scope.row.tipo_id == '8'" @click.native.prevent="printDocumentRemissionPdf(list[scope.$index])"
                  plain round size="mini" type="default" icon="el-icon-printer">
                </el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="Anular" placement="top">
                <el-button v-if="scope.row.anulado != 1"
                  @click.native.prevent="showCancelDocument(scope.$index, scope.row)" type="danger" plain round
                  size="mini" icon="el-icon-delete" class="">
                </el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="Eliminar" placement="top">
                <el-popconfirm v-if="list[scope.$index].detail_count == 0" confirm-button-text='Confirmar'
                  cancel-button-text='Cancelar' icon="el-icon-info" icon-color="red" title="Confirmar eliminación"
                  @confirm="deleteRow(list[scope.$index])">
                  <el-button slot="reference" type="danger" plain round size="mini" icon="el-icon-document-delete"
                    class="ml-10">
                  </el-button>
                </el-popconfirm>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="list.length > 0" class="pagination-box" style="text-align: end; padding-top: 10px">
          <el-pagination layout="total, prev, pager, next" :page-size="page_size" :total="total_rows"
            @current-change="handleCurrentPage"></el-pagination>
        </div>
      </el-row>
    </el-dialog>
    <print-document :show="showPrint" @close="closeModalPrint" />
  </div>
</template>
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { getAdjustInputOutput, cancelDocument } from "@/api/inputOutputAdjust";
import { deleteDocument,printPdf, printRemissionPdf } from "@/api/document";
import PrintDocument from "@/views/apps/inputOutputAdjust/PrintDocument.vue"
export default {
  name: "ListComponent",
  components: { PrintDocument },
  data() {
    return {
      popoverVisible: false,
      loadingTable: false,
      loading: false,
      dialogListVisible: false,
      list: [],
      sucursal_id: null,
      type_document: null,
      //paginate
      page_size: 8,
      current_page: 1,
      total_rows: 0,
      // filter
      pickerOptions: {
        shortcuts: [
          {
            text: "Última semana",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Último mes",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Últimos tres meses",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      date_start: null,
      date_end: null,
      document: null,
      // print
      showPrint: false,
    };
  },
  computed: {
    ...mapGetters(['isLogged'])
  },
  methods: {
    ...mapMutations(['SET_EDITING', 'SET_DOCUMENT_ID', 'SET_AUDITORY_ID']),
    ...mapActions(['inputAndOutputAdjust/editDocumentAction', 'inputAndOutputAdjust/setDataPrintAction']),
    showCancelDocument(index, row) {
      let me = this
      this.$prompt('Por favor, digita el motivo de la anulación', 'Anular documento #' + row.consecutivo, {
        confirmButtonText: 'Anular',
        cancelButtonText: 'Cancelar',
        inputValidator: me.validateInput,
        closeOnClickModal: false,
        confirmButtonClass: 'el-button--danger'
      }).then(({ value }) => {
        me.executeCancelDocument(row, value);
      }).catch(() => {
        me.$message({
          type: 'info',
          message: 'Anulaión cancelada'
        });
      });
    },
    validateInput(input) {
      if (input === '' || input === null) {
        return 'Campo obligatorio'
      } else if (input.length < 10) {
        return 'Caracteres minimos: 10'
      }
    },
    executeCancelDocument(row, concept) {
      let me = this
      me.loadingTable = true
      cancelDocument({ id: row.id, concept: concept }).then(({ data }) => {
        if (data.code === 200) {
          this.$message.success("Documento anulado");
          this.getAdjust();
        } else {
          this.$message.error("Ha ocurrido un error al intentar anular el documento");
        }
        me.loadingTable = false
      }).catch((e) => {
        me.loadingTable = false
        console.log(e);
        this.$message.error("Error al eliminar el documento.");
      })
    },
    openList() {
      this.dialogListVisible = true;
      this.sucursal_id = this.isLogged.branch.id;
      this.type_document = this.$route.meta.typeDocument;
      this.getAdjust();
    },
    getAdjust() {
      let me = this;
      me.loading = true
      me.loadingTable = true
      if (me.date_end != null || me.document != null) {
        me.current_page = 1;
      }
      getAdjustInputOutput(
        me.page_size,
        me.current_page,
        me.sucursal_id,
        me.type_document,
        me.document,
        me.date_end,
      )
        .then(({ data }) => {
          me.list = data.data;
          me.total_rows = data.total;
          me.loading = false
          me.loadingTable = false
        })
        .catch((e) => {
          me.loadingTable = false
          console.log(e);
          me.$message.error("Error al consultar ajustes.");
          me.loading = false
        });
    },
    handleCurrentPage(val) {
      this.current_page = val;
      this.getAdjust();
    },
    deleteRow(row) {
      deleteDocument(row.id).then(({ data }) => {
        this.$message.success("Ajuste eliminado");
        this.getAdjust();
        console.log(data);
      }).catch((e) => {
        console.log(e);
        this.$message.error("Error al eliminar ajuste.");
      })
      console.log(row.id);
    },
    editDocument(row) {
      this['inputAndOutputAdjust/editDocumentAction'](row.id)
      this.dialogListVisible = false;
    },
    printDocument(row) {
      this['inputAndOutputAdjust/setDataPrintAction'](row.id)
      this.showPrint = true;
    },
    closeModalPrint() {
      this.showPrint = false;
    },
    printDocumentPdf(row) {
      let me = this
      me.loadingTable = true
      printPdf(row.id).then(({ data }) => {
        let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
        width=0,height=0,left=-1000,top=-1000`;
        open(process.env.VUE_APP_ROOT+"storage/documento.pdf", 'DOCUMENT', params);
        me.loadingTable = false
      }).catch((e) => {
        console.log(e);
        me.loadingTable = false
        me.$message.error("Error al generar el documento de impresión.");
      })
    },
    printDocumentRemissionPdf(row) {
      let me = this
      me.loadingTable = true
      printRemissionPdf(row.id).then(({ data }) => {
        let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
        width=0,height=0,left=-1000,top=-1000`;
        open(process.env.VUE_APP_ROOT+"storage/Remision.pdf", 'REMISION', params);
        me.loadingTable = false
      }).catch((e) => {
        console.log(e);
        me.loadingTable = false
        me.$message.error("Error al generar el documento de impresión.");
      })
    },
  },
};
</script>